if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');

      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      const { refreshMiniCart } = window.smk.cart;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          const { components: { miniCart: { reference: miniCartRef } } } = window.smk.config;

          if(refreshMiniCart) {
            var isAddedInMain = document.querySelector('#is-added-in-main');
            var isAddedInUpsell = document.querySelector('#is-added-in-upsell');
            if(isAddedInMain && isAddedInUpsell){
              if(submitButton.classList.contains('product-upsell-button')){
                if(isAddedInMain.checked){
                  refreshMiniCart(true, false);
                }else{
                  refreshMiniCart(true, !$(miniCartRef).hasClass('active') && response);
                }
                isAddedInUpsell.checked = 'checked';
              }else{
                if(isAddedInUpsell.checked){
                  refreshMiniCart(true, false);
                }else{
                  refreshMiniCart(true, !$(miniCartRef).hasClass('active') && response);
                }
                isAddedInMain.checked = 'checked';
              }
            }
            else{
              refreshMiniCart(true, !$(miniCartRef).hasClass('active') && response);
            }
          }

          // this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          // if(refreshMiniCart) {
          //   refreshMiniCart(true);
          // }
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        let alternativeMessage = this.errorMessage.getAttribute('data-error-select-size-message');
        this.errorMessage.textContent = errorMessage.includes(': id') && alternativeMessage ? alternativeMessage : errorMessage.in;
      }
    }
  });
}
